export function PageLoading() {
  return (
    <div className="flex min-h-[280px] items-center justify-center">
      <p className="text-muted-foreground">Loading...</p>
    </div>
  );
}
